import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class YearEndProcessService {
    private baseApiUrl: string;

    constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }
 

    searchProvisionAmount(type: number, producttype: number,fromDate: Date,toDate: Date): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `yearendprocess/searchprovisionamount/?fromDate=${fromDate}&toDate=${toDate}&type=${type}&producttype=${producttype}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    payProvisionAmount(provision:any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `yearendprocess/payProvisionAmount`, provision).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


  }
